/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import {
  ShipmentGroupSolutionSegmentDefinitionDtoModel,
  ShipmentGroupSolutionSegmentRouteDtoModel,
} from '@well/delivery-libs/shipment/domain';
import { CurrencyValueModel } from '@well/domain';
import { TaskDtoModel } from './task-dto.model';

export class TaskListWithSolutionBaseDtoModel extends JSONable {
  definition: ShipmentGroupSolutionSegmentDefinitionDtoModel | null = null;
  segmentRoute: ShipmentGroupSolutionSegmentRouteDtoModel | null = new ShipmentGroupSolutionSegmentRouteDtoModel();
  taskDTOs: TaskDtoModel[] = [];
  cost: CurrencyValueModel | null = null;
  instructions: string | null = null;
}

export class TaskListWithSolutionDtoModel extends TaskListWithSolutionBaseDtoModel {
  originalShipmentGroupUuid: string | null = null;
}
